import React, { useEffect, useState } from 'react'
import { Modal } from 'antd'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { get, post } from '../../Common/api'
import ConfirmedSlot from './ConfirmedSlot'
import SlotLayout from './SlotLayout'
import { ExclamationCircleOutlined } from '@ant-design/icons'
const { confirm } = Modal

export default function SlotPage () {
  const { id } = useParams()
  const { t } = useTranslation()
  const [slot, setSlot] = useState(null)
  const [slotStatus, setSlotStatus] = useState(null)

  const updateStatus = (json) => {
    if (json?.calendoc_timeout) setSlotStatus('timeout')
    else if (json?.is_cancel) setSlotStatus('cancel')
    else setSlotStatus('confirmed')
  }
  const onCancel = () => {
    confirm({
      icon: <ExclamationCircleOutlined />,
      content: t('Public.ConfirmedSlot.modalConfirm'),
      onOk () {
        post(`public/slots/${slot.id}/cancel`, {}, (json) => {
          setSlot(json)
          updateStatus(json)
        })
      }
    })
  }

  useEffect(() => {
    get(`public/slots/${id}`, {}, (json) => {
      setSlot(json)
      updateStatus(json)
    })
  }, [id])

  const date = slot?.begin_date
  const box = slot?.box
  const titles = {
    timeout: 'TimeoutSlotPage',
    cancel: 'CancelSlotPage',
    confirmed: 'ConfirmedSlotPage'
  }
  const title = titles[slotStatus]
  return (
    <SlotLayout date={date} box={box} title={t(`Public.${title}.title`)} disabled={true} slot={slot}>
      {slotStatus && <ConfirmedSlot box={box} slot={slot} onCancel={onCancel} slotStatus={slotStatus} />}
    </SlotLayout>
  )
}
